/* lib/api/skills.js — реестр чат-скиллов (порт из frontend/src/lib/api/skills.js, 1:1).
 * GET /api/chats/skills/ → [{slug,name,hint,starter_hint,description,inputs,outputs,examples}]. */
import { apiFetch } from './client.js';

export const listSkills = () => apiFetch('/api/chats/skills/');
